import React from 'react'

const EQViewerFooter = () => (
  <p>
  Dirección Diagonal 53 No.34-53 - Bogotá D.C Colombia. - Linea de
  atención Servicio Geológico Colombiano (601)2000200
  </p>
)

export default EQViewerFooter 